import { render, staticRenderFns } from "./GoalsQuestions.vue?vue&type=template&id=3e8f4330&"
import script from "./GoalsQuestions.vue?vue&type=script&lang=ts&"
export * from "./GoalsQuestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports